import Marquee from "react-fast-marquee";
import { Plus } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function EditorialMarquee() {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div data-testid="editorial-marquee" className="border-y border-ink/10 bg-white py-5" aria-hidden="true">
      <Marquee speed={28} gradient={false} pauseOnHover={false}>
        {[...items, ...items].map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-16">
            <span className="text-xs font-medium uppercase tracking-[0.35em] text-ink/70">{item}</span>
            <Plus className="h-3 w-3 text-cobalt" strokeWidth={2} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
